import React from "react";
import "../../../../../styles/Pages/Financial/CashInFlow/Dashboard/OthersList.style.css";

const OthersList = ({ listData }) => {
  return (
    <div className="othersListTableContainer">
      <div className="OthersListHeader">
        <h2 className="title">Others</h2>
        <span className="persons-count">{listData.length} persons</span>
      </div>
      <div className="tableContainer scroll-y">
        <table className="data-table">
          <thead>
            <tr className="header-row">
              <th className="cell header-cell">Name & Gid</th>
              <th className="cell header-cell">Contact</th>
              <th className="cell header-cell">Date</th>
              <th className="cell header-cell">Grants</th>
            </tr>
          </thead>
          <tbody>
            {listData.map((item, index) => (
              <tr
                key={index}
                className={`data-row ${
                  index === listData.length - 1 ? "faded-row" : ""
                }`}
              >
                <td className="cell">
                  {item.name}
                  <br />
                  <span className="gid">Gid: {item.gid}</span>
                </td>
                <td className="cell contact-cell">{item.contact}</td>
                <td className="cell">{item.date}</td>
                <td className="cell">{item.grants}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default OthersList;
